import FieldConfig from "../../../../proto/field-config"
import FieldProto from "../../../../proto/field-proto"
import FieldTaskLeadTime_TableCell from "./render/table/table-cell"
import {Duration} from "moment"
import {SortDirection} from "../../../../../data-structures/sort"
import ItemModel from "../../../../../model2/item/item-model"

const debug = false
// const debug = "FieldTaskLeadTime"

export default class FieldTaskLeadTime extends FieldProto {

    constructor(config:FieldConfig) {
        super(config)

        this.icon               = 'i5-lead-time'

        this.typeLabel          = "Lead time"
        this.typeDescription    = "Lead time field"

        this.label              = _.get(config, 'label', this.typeLabel)

        this.renderComponents.tableCell     = FieldTaskLeadTime_TableCell
    }

    getViewValue(model: any): any {
        const duration: Duration = _.get(model, this.fieldId, null)

        debug && console.log(debug, 'getViewValue', duration, this.fieldId, model)

        return duration ? gd.utils.momentIntervalHumanize(duration) : '' //duration?.humanize()
    }

    listItemSortFunctions(sort: SortDirection) {
        return {
            functions   : [
                (listItem:ItemModel) => {
                    const duration: Duration = _.get(listItem.item, this.fieldId, moment.duration(0, 'seconds'))
                    return duration.asMinutes()
                }
            ],
            directions  : [sort]
        }
    }
}
